import React from 'react';
import NewProductReleases from 'src/components/new-product-releases';
import { useGqlQuery } from 'src/hooks/use-gql-query';
import type { NewProductsQuery } from 'src/types';
import query from './query.graphql';

export const NewProducts: React.FC = () => {
  const result = useGqlQuery<NewProductsQuery>({
    query,
    queryKey: ['newProducts'],
  });

  const newReleases = result.data?.newProductRecommendations?.newReleases
    ?.nodes as any[];

  if (result.isError || !newReleases) {
    return null;
  }

  return <NewProductReleases negativeMargin newReleases={newReleases} />;
};
